import React, { ReactNode } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ReactComponent as WarningTriangleIcon } from '../../../assets/images/warning-triangle-icon.svg';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import './ConfigurationDimensionChangeDialog.scss';

interface ConfigurationDimensionChangeDialogProps {
    visible: boolean;
    onHide: () => void;
    assignedDevicesCount?: number;
}

const ConfigurationDimensionChangeDialog: React.FC<ConfigurationDimensionChangeDialogProps> = ({
    visible,
    onHide,
    assignedDevicesCount = 0,
}) => {
    const { t } = useTranslation();

    const renderFooter = (): ReactNode => (
        <div className="configuration-dimension-change-dialog__footer">
            <Button
                label={t(
                    'planogram.configurationDimensionChange.close',
                    'Close',
                )}
                onClick={onHide}
                className="configuration-dimension-change-dialog__button"
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={t(
                'planogram.configurationDimensionChange.title',
                'Changed configuration',
            )}
            className="configuration-dimension-change-dialog"
            closable
            closeOnEscape
            modal
            draggable={false}
            resizable={false}
            focusOnShow
            footer={renderFooter()}
        >
            <div className="flex flex-column gap-3">
                <div className="warning-section">
                    <WarningTriangleIcon className="warning-icon" />

                    <span className="warning-text">
                        {t(
                            'planogram.configurationDimensionChange.warning',
                            'Warning: Assigned devices',
                        )}
                    </span>
                </div>

                <div className="description">
                    {t(
                        'planogram.configurationDimensionChange.message',
                        'Changing the planogram layout may make the currently assigned device or devices incompatible with this planogram. Please unassign the planogram from selected devices and repeat the operation.',
                    )}
                </div>

                <div className="device-info-section">
                    <label className="field-label mb-0">
                        {t(
                            'planogram.configurationDimensionChange.devicesLabel',
                            'DEVICES',
                        )}
                    </label>

                    <div className="assigned-count-badge">
                        <span className="assigned-label">
                            {t(
                                'planogram.configurationDimensionChange.assignedLabel',
                                'Assigned:',
                            )}
                        </span>

                        <span className="assigned-count">
                            {assignedDevicesCount}
                        </span>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfigurationDimensionChangeDialog;